'use client'

import { apiKey, useApi } from '@excellent/ui/api'
import { lens } from '@excellent/ui/api/contracts/lens'
import type { DashboardSnapshot } from '@lens/lib/snapshot'

// Cache key kept stable for legacy `mutate(SNAPSHOT_KEY)` callers.
export const SNAPSHOT_KEY = apiKey(lens.snapshot, {})
export type { DashboardSnapshot }

/**
 * Subscribe to the shared dashboard snapshot. Every page that needs aggregated
 * data goes through this hook so the snapshot is fetched, cached, and
 * revalidated exactly once across the entire app.
 */
export function useSnapshot(): {
  snapshot: DashboardSnapshot | undefined
  error: Error | undefined
  isLoading: boolean
} {
  const { data, error, isLoading } = useApi(lens.snapshot, {})
  return {
    snapshot: data as DashboardSnapshot | undefined,
    error: error as Error | undefined,
    isLoading,
  }
}
